import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router";
import CreateYearSettings from "./addYearSettings";
import "./hm-theme.css";

function FinancialYearSettings() {
  const [financialYear, setFinancialYear] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = JSON.parse(localStorage.getItem("data")).token;

  const getData = async () => {
    setLoading(true);
    try {
      const performanceTargetResponse = await axios.get(`/api/year-settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFinancialYear(performanceTargetResponse.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const handleAddProduct = () => {
    setIsModalOpen(true);
  };

  const handleAddCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  return (
    <div>
      <AdminDashboard />
      <div className="col-10 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">calendar_today</i>
                Financial Year Settings
              </h2>
              <p className="hm-page-subtitle">
                Configure fiscal year periods and date boundaries for reporting.
              </p>
            </div>
          </div>

          {/* Main Card */}
          <div className="hm-card">
            <div className="hm-card-header d-flex align-items-center justify-content-between">
              <h3 className="hm-card-title mb-0">
                <i className="material-icons">date_range</i>
                Fiscal Year Period
              </h3>
              <button className="btn-hm-primary" onClick={handleAddProduct}>
                <i className="material-icons" style={{ fontSize: "1rem" }}>
                  {financialYear.length > 0 ? "edit" : "add"}
                </i>
                {financialYear.length > 0 ? "Update" : "Add"}
              </button>
            </div>
            <div className="hm-card-body p-0">
              {loading && <div className="loading"></div>}
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>From Date</th>
                      <th>To Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {financialYear.length === 0 ? (
                      <tr>
                        <td colSpan="2">
                          <div className="hm-empty-state py-4">
                            <i className="material-icons">calendar_today</i>
                            <p>{loading ? "Loading settings..." : "No financial year settings configured"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      financialYear.map((financiaYear) => (
                        <tr key={financiaYear.id || financiaYear.fromDate}>
                          <td className="fw-semibold">{financiaYear.fromDate}</td>
                          <td className="fw-semibold">{financiaYear.toDate}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <CreateYearSettings isOpen={isModalOpen} onRequestClose={handleAddCloseModal} />
      )}
    </div>
  );
}

export default FinancialYearSettings;

